var StandardIconType = /*#__PURE__*/ function(StandardIconType) {
    StandardIconType["ACCOMPLISHMENTS"] = "ACCOMPLISHMENTS";
    StandardIconType["ACTIVITY"] = "ACTIVITY";
    StandardIconType["AI"] = "AI";
    StandardIconType["ALERT"] = "ALERT";
    StandardIconType["ANALYTICS"] = "ANALYTICS";
    StandardIconType["ARROW_DOWN"] = "ARROW_DOWN";
    StandardIconType["ARROW_LEFT"] = "ARROW_LEFT";
    StandardIconType["ARROW_RIGHT"] = "ARROW_RIGHT";
    StandardIconType["ARROW_TO_DOWN_LINE"] = "ARROW_TO_DOWN_LINE";
    StandardIconType["ARROW_TO_UP_LINE"] = "ARROW_TO_UP_LINE";
    StandardIconType["ARROW_UP"] = "ARROW_UP";
    StandardIconType["BELL_OFF"] = "BELL_OFF";
    StandardIconType["BELL_RING"] = "BELL_RING";
    StandardIconType["BOT"] = "BOT";
    StandardIconType["CALENDAR"] = "CALENDAR";
    StandardIconType["CARD"] = "CARD";
    StandardIconType["CARET_UP_FILLED"] = "CARET_UP_FILLED";
    StandardIconType["CHANNEL"] = "CHANNEL";
    StandardIconType["CHECK"] = "CHECK";
    StandardIconType["CHEVRON_DOWN"] = "CHEVRON_DOWN";
    StandardIconType["CHEVRON_DOWN_PIXEL"] = "CHEVRON_DOWN_PIXEL";
    StandardIconType["CHEVRON_RIGHT"] = "CHEVRON_RIGHT";
    StandardIconType["CHOOSE_STATS"] = "CHOOSE_STATS";
    StandardIconType["CLOCK"] = "CLOCK";
    StandardIconType["CODE"] = "CODE";
    StandardIconType["COLUMNS"] = "COLUMNS";
    StandardIconType["COMPANY"] = "COMPANY";
    StandardIconType["COMPARISON"] = "COMPARISON";
    StandardIconType["CONNECT"] = "CONNECT";
    StandardIconType["CONNECTIONS"] = "CONNECTIONS";
    StandardIconType["COPY"] = "COPY";
    StandardIconType["COST"] = "COST";
    StandardIconType["DEBUG"] = "DEBUG";
    StandardIconType["DEEP_DIVE"] = "DEEP_DIVE";
    StandardIconType["DELIVERY"] = "DELIVERY";
    StandardIconType["DEVICE_DESKTOP_ANALYTICS"] = "DEVICE_DESKTOP_ANALYTICS";
    StandardIconType["DISCONNECT"] = "DISCONNECT";
    StandardIconType["DOCUMENT"] = "DOCUMENT";
    StandardIconType["DOT"] = "DOT";
    StandardIconType["DUO_CLIPBOARD"] = "DUO_CLIPBOARD";
    StandardIconType["DUO_CLOCK"] = "DUO_CLOCK";
    StandardIconType["DUO_LAMP"] = "DUO_LAMP";
    StandardIconType["DUO_MESSAGE"] = "DUO_MESSAGE";
    StandardIconType["DUO_CALENDAR"] = "DUO_CALENDAR";
    StandardIconType["DUO_USER_CARD"] = "DUO_USER_CARD";
    StandardIconType["DUO_CHECK_CIRCLE"] = "DUO_CHECK_CIRCLE";
    StandardIconType["EDIT"] = "EDIT";
    StandardIconType["EMAIL"] = "EMAIL";
    StandardIconType["EMPLOYEE"] = "EMPLOYEE";
    StandardIconType["EMPLOYEES"] = "EMPLOYEES";
    StandardIconType["ERROR"] = "ERROR";
    StandardIconType["EXTERNAL_LINK"] = "EXTERNAL_LINK";
    StandardIconType["EYE"] = "EYE";
    StandardIconType["FEATURE_INDETERMINATE"] = "FEATURE_INDETERMINATE";
    StandardIconType["FEATURE_OFF"] = "FEATURE_OFF";
    StandardIconType["FEATURE_ON"] = "FEATURE_ON";
    StandardIconType["FEATURES"] = "FEATURES";
    StandardIconType["FEEDBACK_GIVEN"] = "FEEDBACK_GIVEN";
    StandardIconType["FEEDBACK_RECEIVED"] = "FEEDBACK_RECEIVED";
    StandardIconType["FILTER"] = "FILTER";
    StandardIconType["FLAG"] = "FLAG";
    StandardIconType["FULL_SCREEN"] = "FULL_SCREEN";
    StandardIconType["GLOBE"] = "GLOBE";
    StandardIconType["GRID_DOTS"] = "GRID_DOTS";
    StandardIconType["HAMBURGER"] = "HAMBURGER";
    StandardIconType["HAPPY"] = "HAPPY";
    StandardIconType["HEALTH"] = "HEALTH";
    StandardIconType["HERO_NUMBER"] = "HERO_NUMBER";
    StandardIconType["HIGHLIGHTS"] = "HIGHLIGHTS";
    StandardIconType["HOME"] = "HOME";
    StandardIconType["HOME_GRID"] = "HOME_GRID";
    StandardIconType["IMPACT"] = "IMPACT";
    StandardIconType["INFO_CIRCLE"] = "INFO_CIRCLE";
    StandardIconType["INTEGRATIONS"] = "INTEGRATIONS";
    StandardIconType["KEY"] = "KEY";
    StandardIconType["KEYBOARD_DOUBLE_ARROW_RIGHT"] = "KEYBOARD_DOUBLE_ARROW_RIGHT";
    StandardIconType["KEYBOARD_SINGLE_ARROW_RIGHT"] = "KEYBOARD_SINGLE_ARROW_RIGHT";
    StandardIconType["LEADERBOARD"] = "LEADERBOARD";
    StandardIconType["LIGHTNING_BOLT"] = "LIGHTNING_BOLT";
    StandardIconType["LIGHT_BULB"] = "LIGHT_BULB";
    StandardIconType["LINK"] = "LINK";
    StandardIconType["LINKED_IN"] = "LINKED_IN";
    StandardIconType["LOADING"] = "LOADING";
    StandardIconType["LOCK"] = "LOCK";
    StandardIconType["LOGOUT"] = "LOGOUT";
    StandardIconType["MAILBOX"] = "MAILBOX";
    StandardIconType["MAPPING"] = "MAPPING";
    StandardIconType["MEETINGS"] = "MEETINGS";
    StandardIconType["MEDAL"] = "MEDAL";
    StandardIconType["MEDAL_RIBBON"] = "MEDAL_RIBBON";
    StandardIconType["MERGE"] = "MERGE";
    StandardIconType["NEW_ACTIVITY"] = "NEW_ACTIVITY";
    StandardIconType["NEW_TAB"] = "NEW_TAB";
    StandardIconType["NOTIFICATIONS"] = "NOTIFICATIONS";
    StandardIconType["ORG_CHART"] = "ORG_CHART";
    StandardIconType["ORGS"] = "ORGS";
    StandardIconType["PAINT_BRUSH"] = "PAINT_BRUSH";
    StandardIconType["PANEL_LEFT_CLOSE"] = "PANEL_LEFT_CLOSE";
    StandardIconType["PANEL_LEFT_OPEN"] = "PANEL_LEFT_OPEN";
    StandardIconType["PENCIL_BOLT"] = "PENCIL_BOLT";
    StandardIconType["PERSON"] = "PERSON";
    StandardIconType["PERSON_CHECK"] = "PERSON_CHECK";
    StandardIconType["PERSON_MULTIPLE_CHECK"] = "PERSON_MULTIPLE_CHECK";
    StandardIconType["PLAY_CIRCLE"] = "PLAY_CIRCLE";
    StandardIconType["PLUS"] = "PLUS";
    StandardIconType["PLUS_CIRCLE"] = "PLUS_CIRCLE";
    StandardIconType["RECORDING"] = "RECORDING";
    StandardIconType["REFRESH"] = "REFRESH";
    StandardIconType["ROBOT_FACE"] = "ROBOT_FACE";
    StandardIconType["SAD"] = "SAD";
    StandardIconType["SAVED_VIEW"] = "SAVED_VIEW";
    StandardIconType["SEARCH"] = "SEARCH";
    StandardIconType["SEND"] = "SEND";
    StandardIconType["SETTINGS"] = "SETTINGS";
    StandardIconType["SMS"] = "SMS";
    StandardIconType["SPINNER"] = "SPINNER";
    StandardIconType["STAR"] = "STAR";
    StandardIconType["STAR_FILLED"] = "STAR_FILLED";
    StandardIconType["STATS"] = "STATS";
    StandardIconType["SUMMARY"] = "SUMMARY";
    StandardIconType["SUPERPOWERS"] = "SUPERPOWERS";
    StandardIconType["SWITCH"] = "SWITCH";
    StandardIconType["SYNC_INTEGRATION"] = "SYNC_INTEGRATION";
    StandardIconType["TABLE"] = "TABLE";
    StandardIconType["TAG"] = "TAG";
    StandardIconType["TEAM"] = "TEAM";
    StandardIconType["TELESCOPE"] = "TELESCOPE";
    StandardIconType["TEST"] = "TEST";
    StandardIconType["THREE_DOTS_VERTICAL"] = "THREE_DOTS_VERTICAL";
    StandardIconType["THUMBS_UP"] = "THUMBS_UP";
    StandardIconType["TIME_SPENT"] = "TIME_SPENT";
    StandardIconType["TRENDING_DOWN"] = "TRENDING_DOWN";
    StandardIconType["TRENDING_UP"] = "TRENDING_UP";
    StandardIconType["TRASH"] = "TRASH";
    StandardIconType["TWITTER"] = "TWITTER";
    StandardIconType["USER"] = "USER";
    StandardIconType["USER_CIRCLE"] = "USER_CIRCLE";
    StandardIconType["USER_PLUS"] = "USER_PLUS";
    StandardIconType["WINDY"] = "WINDY";
    StandardIconType["WRENCH"] = "WRENCH";
    StandardIconType["X"] = "X";
    StandardIconType["YOUTUBE"] = "YOUTUBE";
    return StandardIconType;
}(StandardIconType || {});
export default StandardIconType;
